var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4941 8.88599V16.1406C16.4941 19.7305 13.584 22.6406 9.99414 22.6406C6.40429 22.6406 3.49414 19.7305 3.49414 16.1406C3.49414 12.5507 6.40429 9.64062 9.99414 9.64062C10.5104 9.64062 11.0126 9.70082 11.4941 9.81456V12.9774C11.0395 12.7614 10.5309 12.6406 9.99414 12.6406C8.06114 12.6406 6.49414 14.2076 6.49414 16.1406C6.49414 18.0736 8.06114 19.6406 9.99414 19.6406C11.9271 19.6406 13.4941 18.0736 13.4941 16.1406V2.64062H16.4941C16.4941 5.40205 18.7327 7.64062 21.4941 7.64062V10.6406C19.6022 10.6406 17.8637 9.9839 16.4941 8.88599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.acdfd7b17a2821765df3bb261dda05d7.svg";
export { ForwardRef as ReactComponent };